/** What a contest card says about the reader's own entry, and whether it is about them (signal orange). */
export interface EntryLine {
  text: string;
  /** About an entry the reader holds — what earns the accent. */
  self: boolean;
}

/**
 * The contest card's line about the reader's entry (#234), from the server's count of their own entries
 * (`myEntries`, the team list's definition of "mine").
 *
 * Orange means "this is you" on this side of the glass, so only an entry the reader holds is orange; not having
 * entered is a fact about them too, but nothing to mark. On a portal staff are browsing (`readOnly`) there is no
 * line at all: the count is the staff member's own, and the card would be saying it about the player on screen.
 */
export function entryLine(
  contest: { myEntries: number },
  status: 'draft' | 'open' | 'locked' | 'closed',
  readOnly: boolean,
): EntryLine | null {
  if (readOnly) return null;
  if (contest.myEntries > 0) {
    return { text: contest.myEntries === 1 ? 'You’re in' : `You’re in · ${contest.myEntries} teams`, self: true };
  }
  return { text: status === 'open' ? 'You haven’t entered' : 'You didn’t enter', self: false };
}
